// extracted by mini-css-extract-plugin
module.exports = {"buttonModal":"OrderDeleteAuditedOTD_buttonModal__25NAV"};